import * as Cache from './CalculationCache';

export type MBase = {
  [method in string]: Cache.IO;
};

type ValueOf<T> = T[keyof T];

export type SA<M extends MBase> = {
  state: { [method in keyof M]: Cache.Type<M[method]> };
  action: ValueOf<{
    [method in keyof M]: {
      method: method;
      action: Cache.Action<M[method]>;
    };
  }>
};

export function updateObject<T, K extends keyof T>(
  obj: T,
  key: K,
  value: T[K],
): T {
  return Object.assign({}, obj, { [key]: value });
}

export function reduce<M extends MBase, Action extends SA<M>['action']>(
  caches: SA<M>['state'],
  action: SA<M>['action'],
): SA<M>['state'] {
  return updateObject(
    caches,
    action.method,
    Cache.reduce<M[Action['method']]>(caches[action.method], action.action)
  );
}



// WEBPACK FOOTER //
// ./src/state/GenericCalculator.ts